import styled, { css } from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos RegisterModal
Description : Se definen los estilos de los elementos del resto del formulario
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen estilos y elementos del formulario
================================================================================ */

export const FormGroup = styled.div`
    color: palevioletred;
    width: 300px;
    height: 30px;
    margin: 50px;
    margin-top: -5px;
`;

export const Form = styled.form`
    width: 400px;
    margin: auto;
    border-radius: 8px;
    height: 100vh;
`;

export const Button = styled.button`
    margin-bottom: 10px;
`;

export const Label = styled.label`
    display: block;
    margin-top: -5px;
`;

export const Input = styled.input`
	padding: 0.5em;
	width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
`;

export const H2 = styled.h2`
    text-align: center;
`;

export const Image = styled.img`
    width: 40%;
    margin-top: 0.5em;
`;

export const H3 = styled.h3`
    color: white;

`;
export const Select = styled.select`
    padding: 0.5em;
    width:100%;
    margin-top: -3px;
    margin-bottom: -3px;

    option {
        display: flex;
        white-space: pre;
        min-height: 20px;
        padding: 0px 2px 1px;
      }
`;